/**
 * @fileoverview GET handler for the "/engagement/location_set_data" endpoint
 */
import type { EngagementLocationSetDataResult } from "@dashboardApi/apis/engagementGeofencesData";

import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementLocationSetData } from "./constants";

export const getEngagementLocationSetData = reactQueryFetcherAdapter(
  engagementLocationSetData,
  (signal: AbortSignal, locationSetId: string): Promise<EngagementLocationSetDataResult> => {
    return fetch("/engagement/location_set_data", "GET", { location_set_id: locationSetId }, { signal });
  }
);
